import { AuthenticatedUser } from './authenticated-user';

export class AuthenticatedContext {
    user: AuthenticatedUser
}
